export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-8c-64855132fd576d29f4092c4e88f20ea7.webp";